/*
  Displays a sampling of books (Book components) for a given shelf
*/
import React from "react";
import Reflux from "reflux";
import _ from "lodash";
import GrComponentFactory from "./gr_component_factory";
import { getImages } from "../modules/shared/image_registry";

// STORES
import BooksOnShelvesStore from "../react_stores/books_on_shelves_store";

export default GrComponentFactory.createClass({
  displayName: "ShelfDisplay",

  propTypes: {
    askForRecommendationsUrl: React.PropTypes.string.isRequired,
    numToDisplay: React.PropTypes.number,
    recommendationsUrl: React.PropTypes.string.isRequired,
    shelfImageUrl: React.PropTypes.string.isRequired,
    shelfName: React.PropTypes.string.isRequired,
    shelfUrl: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      numToDisplay: 6,
      shelfUrl: null,
    };
  },

  mixins: [
    Reflux.connectFilter(
      BooksOnShelvesStore,
      "shelvings",
      function(storeData) {
        return _.sortByOrder(_.values(storeData[this.props.shelfName]),
                             (shelving) => shelving.updatedAt,
                             "desc")
          .slice(0, this.props.numToDisplay);
      }
    ),
  ],

  // Starting point for GR-32455. Won't work exactly as-is:
  // * UserShelf component deleted
  /*
  renderShelfChooser() {
    let caret = <img className="secondaryColumnSection__caret" src={this.props.caretImage} />;
    let allShelves = _.compact(this.state.userShelves.defaultShelves
      .concat(this.state.userShelves.customExclusiveShelves)
      .concat(this.state.userShelves.nonExclusiveShelves));

    return <Dropdown trigger={caret}
                     fallbackUrl="/review/list"
                     bemModifiers="shelfDisplay">
             <DropDownList maxListItems={this.props.maxShelves}
                           moreLinkURL={this.props.moreShelvesLink}
                           showMoreLink={true}>
               { _.map(_.slice(allShelves, 0, this.props.maxShelves), (shelf) => {
                   return(<MenuLink key={shelf.name}>
                            <UserShelf key={shelf.name} shelfName={shelf.name} />
                          </MenuLink>);
                 })
               }
             </DropDownList>
           </Dropdown>;
  },
  */

  renderShelfLink() {
    if (this.props.shelfUrl && !_.isEmpty(this.state.shelvings)) {
      return <div className="u-marginTopXSmall">
               <a href={this.props.shelfUrl}
                  aria-label={`View your ${this.props.shelfName} shelf`}>
                 View all books
               </a>
             </div>;
    } else {
      return null;
    }
  },

  renderShelvings() {
    if (!_.isEmpty(this.state.shelvings)) {
      return _.map(this.state.shelvings, (shelving) => (
            <a key={shelving.book.bookId}
              className="shelfDisplay__bookCoverLink"
              href={shelving.book.bookUrl}>
              <img alt={shelving.book.title}
                    src={shelving.book.imageUrls.crop96x96}
                    className="gr-bookCover gr-bookCover--thumbnailSmall" />
            </a>
      ));
    } else {
      return <div>
               <div className="gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter">
                <img className="gr-mediaFlexbox__media" alt="" src={getImages().wtrSparseStateIcon}/>
                <div className="gr-mediaFlexbox__desc">
                  What do you want to read next?
                </div>
               </div>
               <div className="u-marginTopMedium">
                <a href={this.props.recommendationsUrl}>
                 Recommendations
                </a>
               </div>
             </div>;
    }
  },

  render() {
    return(
      <div className="shelfDisplay">
        {this.renderShelvings()}
        {this.renderShelfLink()}
      </div>
    );
  },
});
